/**
 * Fastest way to copy object literal
 * @param {any} obj
 */
export default function cypy(obj: unknown) {
    return JSON.parse(JSON.stringify(obj || {}));
}
